"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Link_1 = require("@material-ui/core/Link");
var react_router_1 = require("react-router");
var Authentication_1 = require("src/Authentication");
var Routing_1 = require("src/Routing");
var LogOutLink = /** @class */ (function (_super) {
    __extends(LogOutLink, _super);
    function LogOutLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (React.createElement(Link_1.default, { component: Routing_1.RouterLink('/logout'), onClick: _this.logOut, className: _this.props.className }, _this.props.children)); };
        /**
         * When called removes the authorization token from the local store
         * and tell the apollo client to reset
         */
        _this.logOut = function (e) {
            e.preventDefault();
            Authentication_1.AuthToken.clearTokens();
            _this.props.history.push('/logOut/');
        };
        return _this;
    }
    return LogOutLink;
}(React.Component));
exports.default = react_router_1.withRouter(LogOutLink);
